import react, { useState, useEffect } from "react";
import { InputImageUpload } from "../../../../Layout/Forms/Form";
import { ButtonDropdown } from "../../../../Layout/Forms/Form";
import NightspotRequests from "../../NightspotRequests";

const Gallery = ({ visible, handleChangeForm, form, formGeneral, showLoading, hideLoading }) => {

    const [optionsOfImages, setOptionsOfImages] = useState([
        {
            label: "Select option",
            value: "Select option"
        },
        // {
        //     label: "Logo",
        //     value: "Logo"
        // },
        // {
        //     label: "Homepage Banner",
        //     value: "Homepage Banner"
        // },
        {
            label: "Exterior",
            value: "Outside"
        },
        {
            label: "Interior",
            value: "Inside"
        },
        {
            label: "Ambiente",
            value: "Environment"
        },
    ]);

    // useEffect(() => {
    //     handleChangeForm(images)
    //     console.log(images)
    // }, [images])

    const handlerRemoveImage = async (key, id) => {
        showLoading();
        let response = await NightspotRequests.deleteVenuesImages(formGeneral.id, id);
        if (response && response.status === true) {
            const updatedArr = form.list.filter(item => item.key !== key);
            handleChangeForm({
                list: updatedArr
            });
        }
        hideLoading();

    }

    const handlerUploadImage = async (images, type) => {
        showLoading();
        let response = await NightspotRequests.uploadVenuesImages(formGeneral.id, images, type);
        if (response && response.status === true) {
            var imagesArr = form;
            response.data.list.map((item) => {

                imagesArr.list.push({
                    "key": Math.floor(Math.random() * 1000),
                    "type": type,
                    "base64": item.image_url,
                    "imgType": "url",
                    "id": item.image_id
                });
                //handlerUploadImage(value)


            })
            console.log(imagesArr)
            handleChangeForm(imagesArr)
        }
        hideLoading();
    }



    const handleImage = (e, type = "") => {

        let image = e.target.files;
        handlerUploadImage(image, type)
        /*Promise.all(Array.from(image).map((img) => {
            return img;
        }))
            .then((urls) => {
                var imagesArr = []
                let imgBS64 = urls.map((item) => {
                    fileBase64(item).then((value) => {
                        let imagesArr = form;
                        imagesArr.list.push({
                            "key": Math.floor(Math.random() * 1000),
                            "type": null,
                            "base64": value,
                            "imgType": "base64",
                            "id": 0
                        });
                        //handlerUploadImage(value)
                        handleChangeForm(imagesArr)

                        // setImages(oldImages => ({
                        //     list: [
                        //         ...oldImages.list, {
                        //         "key": Math.floor(Math.random() * 1000),
                        //         "type": null,
                        //         "base64": value,
                        //         "id": 0
                        //     }]

                        // }));
                    });
                })

            })
            .catch((error) => {
                console.error(error)
            })*/
    }

    const fileBase64 = (img) => {
        return new Promise((resolve, reject) => {
            let fileReader = new FileReader();
            fileReader.onerror = reject
            fileReader.onload = function () {
                resolve(fileReader.result)
            }
            fileReader.readAsDataURL(img)
        })
    }

    const handlerImagetypeSelector = (item, e) => {
        const changeType = form.list.map(value => {
            if (value.key === item.key) {
                return {
                    ...value,
                    type: e.target.value,
                };

            } else {
                return value;
            }
        });
        handleChangeForm({ list: changeType })
    }


    const ListImages = () => {
        const filterArr = ["Logo", "Homepage Banner"]
        return (form.list.filter(objeto => !filterArr.includes(objeto.type))).map((item, index) => {
            //console.log(item)

            return (
                <div className="col-3 d-flex align-items-stretch" style={{ marginTop: '20px' }} key={index} >

                    <div className="card" style={{ width: '100%' }} >
                        <div className="btn-trash" onClick={() => handlerRemoveImage(item.key, item.id)}><i className="fa-solid fa-trash"></i></div>
                        <img src={item.base64} className="card-img-top" alt="Images" style={{ maxHeight: "20vh" }} />
                        <div className="card-body d-flex flex-column">

                            <ButtonDropdown
                                options={optionsOfImages}
                                value={item.type}
                                onChange={(e) => handlerImagetypeSelector(item, e)}
                                error={!item.type || item.type == 'Select option' ? true : false}
                            />
                        </div>
                    </div>
                </div>
            )
        })
    }

    const ImageByTypeLogo = ({ type }) => {
        let obj = form.list.find(item => item.type === type);
        if (obj) {
            return (
                <div className="row g-0 mt-5 mb-3">
                    <div className="col-12 card text-center">
                        <div>
                            <div className="btn-trash" onClick={() => handlerRemoveImage(obj.key, obj.id)}><i className="fa-solid fa-trash"></i></div>
                            <img src={obj.base64} className="card-img-top" alt="Images" style={{ height: '175px', width: '175px', borderRadius: '175px' }} />
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="row g-0 d-flex justify-content-center my-3">
                    <div className="col-12 card text-center">
                        <form encType="multipart/form-data" className="w-100" style={{height: '325px'}}>
                            <InputImageUpload
                                style={{with: '100%' }}
                                onChange={(e) => handleImage(e, type)}
                                accept="image/*"
                            />
                        </form>
                    </div>
                </div>
            )
        }
    }


    const ImageByTypeBanner = ({ type }) => {
        let obj = form.list.find(item => item.type === type);
        if (obj) {
            return (
                <div className="row d-flex justify-content-center my-3">
                    <div className="col-12 card text-center">
                        <div className="btn-trash" onClick={() => handlerRemoveImage(obj.key, obj.id)}><i className="fa-solid fa-trash"></i></div>
                        <img src={obj.base64} className="card-img-top" alt="Images" style={{ height: '175px' }} />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="row d-flex justify-content-center my-3">
                    <div className="col-12 card text-center" >
                        <form encType="multipart/form-data" className="w-100" >
                            <InputImageUpload
                                style={{with: '100%', }}
                                onChange={(e) => handleImage(e, type)}
                                accept="image/*"
                            />
                        </form>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="gallery" style={{ display: !visible ? 'none' : 'block' }}>
            <h3 style={{ marginBottom: '30px' }}>Carregue o seu logótipo e fotografias do seu espaço interior e exterior.</h3>
            <div className="row">
                <div className="col-12 col-sm-4" >
                    <div className="p-2" style={{ backgroundColor: '#00000038' }}>
                        <h4 className="ms-2 mt-2 d-inline">Logotipo</h4>
                        <span className="ms-2" style={{ fontSize: '0.8em' }}>Dimensões (350x350)</span>
                        <ImageByTypeLogo type="Logo" />
                    </div>
                </div>
                <div className="col-12 col-sm-8 " >
                    <div className="p-2" style={{ backgroundColor: '#00000038' }}>
                        <h4 className="ms-2 mt-2 d-inline">Capa</h4>
                        <span className="ms-2" style={{ fontSize: '0.8em' }}>Dimensões (2000x200)</span>
                        <div className="row d-flex justify-content-center my-3">
                            <div className="col-12 col-sm-10 card">
                                <ImageByTypeBanner type="Homepage Banner" />
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <div className="row mt-5">
                <h4>Galeria</h4>
                <ListImages />
                <div className="col-3 d-flex" style={{ marginTop: '20px' }}>
                    <form encType="multipart/form-data" style={{ width: '100%' }}>
                        <InputImageUpload
                            style={{ display: form.list.length >= 15 ? 'none' : 'block', with: '100%' }}
                            onChange={handleImage}
                            accept="image/*"
                        />
                    </form>
                </div>

            </div>
        </div >
    )
}

export default Gallery;